import prod1 from "../assets/prod1.jpg";
import prod2 from "../assets/prod2.jpg";
import prod3 from "../assets/prod3.jpg";
import prod4 from "../assets/prod4.jpg";
import prod5 from "../assets/prod5.jpg";
import prod6 from "../assets/prod6.jpg";
import prod7 from "../assets/prod7.jpg";
import prod8 from "../assets/prod8.jpg";
import prod9 from "../assets/prod9.jpg";
import prod10 from "../assets/prod10.jpg";

const productos = [
    {id: 1, imagen: prod1, nombre:"Coso", descripcion:"No sabemos bien para qué sirve, pero usted seguro que sí", precio: 8500},
    {id: 2, imagen: prod2, nombre:"Cosito", descripcion:"Esto va en un Coso, o eso creemos", precio: 2500},
    {id: 3, imagen: prod3, nombre:"Pendorcho", descripcion:"Lo vendemos porque es barato", precio: 700},
    {id: 4, imagen: prod4, nombre:"Pituto", descripcion:"Útil para varias cosas, usted sabrá", precio: 2000},
    {id: 5, imagen: prod5, nombre:"Chirimbolo", descripcion:"Este no se consigue fácil, cómprelo por las dudas", precio: 12000},
    {id: 6, imagen: prod6, nombre:"Cosoleto", descripcion:"Donde usted crea que pueda entrar, póngalo", precio: 800},
    {id: 7, imagen: prod7, nombre:"Wea", descripcion:"Un Coso de otro país", precio: 1200},
    {id: 8, imagen: prod8, nombre:"Mondá", descripcion:"Un Pendorcho de otro país", precio: 1800},
    {id: 9, imagen: prod9, nombre:"Otro coso", descripcion:"Tampoco sabemos para qué sirve esto", precio: 2700},
    {id: 10, imagen: prod10, nombre:"Artilugio", descripcion:"Sirve para medir algo, pero no sabemos qué", precio: 3200}
]

export default productos;
